export const LIVE_TAIL_NEAR_NOW_MS = 2 * 60 * 1000;

export const isWithinLiveTailWindow = (dateTime?: string, nowMs = Date.now()): boolean => {
    if (!dateTime) return true;

    const parsed = new Date(dateTime);
    if (isNaN(parsed.getTime())) return false;

    return parsed.getTime() >= nowMs - LIVE_TAIL_NEAR_NOW_MS;
};
